// src/App.js
import React, { useEffect, useState, useCallback, useRef } from "react";
//import SimpleBar from 'simplebar-react';
//import 'simplebar-react/dist/simplebar.min.css';


import "@fontsource/cinzel";
import "@fontsource/eb-garamond";
import "@fontsource/bellefair";
import { ChevronUp } from "lucide-react";
import { motion } from "framer-motion";



import Header from "./components/index/Header";
import HeroSection from "./components/index/HeroSection";
import ServicesSection from "./components/index/ServicesSection";
import TestimonialsSection from "./components/index/TestimonialsSection";
import GallerySection from "./components/index/GallerySection";
import ContactSection from "./components/index/ContactSection";
import Footer from "./components/index/Footer";
import MagicParticles from "./components/index/MagicParticles";






export default function Home() {
  const [showTopBtn, setShowTopBtn] = useState(false);
  const [fontsLoaded, setFontsLoaded] = useState(false);
  

  useEffect(() => {
    document.fonts.ready.then(() => setFontsLoaded(true));
    document.body.style.backgroundImage =
      "radial-gradient(circle at top, rgba(255,255,255,0.015) 0%, transparent 80%)";
    document.body.style.backgroundRepeat = "repeat";
    document.body.style.backgroundSize = "cover";

    const handleScroll = () => setShowTopBtn(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
const scrollRef = useRef();
if (!fontsLoaded) {
  return (
    <motion.div
      className="w-screen h-screen flex items-center justify-center bg-eryndra-forest text-eryndra-cream font-title text-3xl"
      initial={{ opacity: 0 }}
      animate={{ opacity: [0, 1, 0.7, 1] }}
      transition={{ duration: 2, repeat: Infinity }}
    >
      Invocando magia...
    </motion.div>
  );
}
  return (
    // <SimpleBar ref={scrollRef} style={{ maxHeight: '100vh' }} autoHide={false}>
    <main className="min-h-screen font-cinzel relative overflow-hidden scroll-smooth bg-eryndra-forest text-eryndra-cream">
      {/* Entrada fade inicial */}
      <motion.div
        className="absolute inset-0 bg-eryndra-forest z-50 pointer-events-none"
        initial={{ opacity: 1 }}
        animate={{ opacity: 0 }}
        transition={{ duration: 2 }}
        style={{ willChange: 'opacity' }}
      />
      
      
      
      {/* Botón scroll top */}
      {showTopBtn && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 z-30 btn-eryndra"
          aria-label="Volver arriba"
        >
          <ChevronUp className="w-5 h-5" />
        </button>
      )}
      
      {/* Contenido */}
      
     

      <div className="bg-eryndra-forest relative z-10">
      <div className="absolute inset-0 z-20 pointer-events-none">
      <MagicParticles />
      </div>
      
      <Header scrollRef={scrollRef} backgroundColor="bg-eryndra-forest/20" />
        <div className="bg-eryndra-hero bg-cover bg-center text-center  py-30 ">          
          <HeroSection />
          
        </div>
        
        <ServicesSection />
        <TestimonialsSection />
        <GallerySection />
        <ContactSection />
        <Footer />
        
      </div>
    </main>
    //</SimpleBar>
  );
}
